<section class="section" id="contact">
  <div class="container">
    <div class="section-head">
      <p class="eyebrow">Contact</p>
      <h2>Construisons quelque chose de solide et ambitieux</h2>
      <p class="section-sub">
        Vous avez un besoin précis ou une vision produit ? Parlons-en.
      </p>
    </div>

    <div class="contact-grid" appReveal>
      <a class="contact-card" [href]="'mailto:' + contact.email">
        <app-icon name="network"></app-icon>
        <div>
          <p>Email</p>
          <span>{{ contact.email }}</span>
        </div>
      </a>
      <a class="contact-card" [href]="contact.linkedin" target="_blank" rel="noopener">
        <app-icon name="pen"></app-icon>
        <div>
          <p>LinkedIn</p>
          <span>{{ contact.linkedin }}</span>
        </div>
      </a>
    </div>
  </div>
</section>
